import { useCallback, useEffect, useState } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

type UsercentricsScope = typeof globalThis & {
  __ucCmp?: {
    isInitialized: () => Promise<boolean>;
  };
};

export const useDisplayAds = (): { displayAdsAllowed: boolean } => {
  const { isLoggedOut } = useLoginState();
  const [cmpInitialized, setCmpInitialized] = useState(false);

  const displayAdsAllowed = isLoggedOut && cmpInitialized;

  const handleCmpInitializeEvent = useCallback((): void => {
    setCmpInitialized(true);
  }, []);

  useEffect(() => {
    let cancelled = false;
    const windowScope: UsercentricsScope = globalThis;

    globalThis.addEventListener('UC_UI_INITIALIZED', handleCmpInitializeEvent);

    // The CMP can initialize before this hook mounts (for example during route loading).
    windowScope.__ucCmp
      ?.isInitialized()
      .then((initialized) => {
        if (initialized && !cancelled) {
          handleCmpInitializeEvent();
        }
      })
      .catch((e) => {
        console.warn('CMP not ready yet', e);
      });

    return () => {
      cancelled = true;
      globalThis.removeEventListener(
        'UC_UI_INITIALIZED',
        handleCmpInitializeEvent
      );
    };
  }, [handleCmpInitializeEvent]);

  return {
    displayAdsAllowed,
  };
};
